import { Drawer, IconButton, ListItem } from '@mui/material';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/styles/config';
import styled from 'styled-components';

export const StyledMobileTTS = styled.div`
  width: 100%;
  height: 96%;
  display: flex;
  flex-direction: column;

  .page-container {
    background-color: ${COLOR.white};
    padding: 0px 8px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .page-container-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .box-preview-desc {
      padding: 0px 10px;
      border-radius: 480px;
    }

    .preview-group {
      display: flex;
      align-items: center;
    }

    .preview-desc {
      font-size: 12px;
      color: ${COLOR.black.default};
      letter-spacing: -0.4px;
    }
    .preview-understood {
      color: #007aff;
      text-decoration: underline;
      cursor: pointer;
    }

    .preview-button {
      font-size: 12px;
      padding: 8px 16px 8px 8px;
      border-radius: 32px;
      text-transform: none;
      border: 1px solid ${COLOR.darkV2[32]};
      font-weight: 500;
    }

    .preview-button-icon {
      margin-right: -6px;
    }
  }

  .text-area-input {
    width: 100%;
    flex: 1;
    border-radius: 4px;
    font-size: 16px;
    box-sizing: border-box;
    resize: none;
    border: none;
    outline: none;
    background-color: ${COLOR.white};
    font-family: 'SF Pro Text', sans-serif;
    color: ${(props) =>
      props.isPlaying ? COLOR.label2[64] : COLOR.label2[100]};
    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLOR.indigo[64]};
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.indigo[80]};
      border-radius: 100px;
    }
  }

  .text-area-input:disabled {
    background-color: ${COLOR.white};
    opacity: 1;
  }

  .count-characters {
    text-align: right;
    text-transform: lowercase;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
    letter-spacing: -0.4px;
    padding-top: 4px;
    color: ${(props) =>
      props.isTooManyChars ? COLOR.error : COLOR.label2[100]};
  }
  .count-characters-max {
    color: ${COLOR.label[64]};
  }

  .close-button {
    font-size: 14px;
    font-weight: 700;
    border-radius: 4px;
  }

  .tool-row {
    padding-bottom: 8px;
  }
`;

export const StyledAudioPlayer = styled.div`
  width: 100%;
  height: 56px;
  box-sizing: border-box;

  .audio-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;
    padding: 12px 16px 4px 16px;
    box-sizing: border-box;

    .audio-info-right-group {
      width: 90px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .emphasis-button {
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .audio-info-left-group {
      width: 90px;
      display: flex;
      gap: 16px;

      .break-time-button {
        color: ${COLOR.indigo[64]};
      }
      .break-time-button:disabled {
        color: ${COLOR.disableButton};
        opacity: 1;
      }
    }

    .rewind-button {
      padding: 6px;
      color: ${COLOR.indigo[64]};
    }
  }

  .control-audio {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .audio-action-button {
    padding: 6px;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    min-width: 0;
  }

  .voice {
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .speed {
    color: ${COLOR.indigo[100]};
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    border: 2px solid ${COLOR.indigo[64]};
    border-radius: 100px;
    cursor: pointer;
  }
`;

export const StyledSpeedDrawer = styled.div`
  width: 100%;
  .MuiList-root {
    padding: 0px;
  }
  .list-item {
    margin-bottom: 2px;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
    box-sizing: border-box;
    min-width: 100px;
  }

  .list-item:last-child {
    margin-bottom: 0;
  }

  .list-item .MuiListItemButton-root {
    width: 100%;
    height: 100%;
    padding: 8px 16px;
    justify-content: center;
  }

  .item-break-time {
    display: flex;
    justify-content: center;
    padding: 6px 16px;
  }

  .show-speed {
    display: flex;
    align-items: center;
    padding: 6px 16px;
    width: 160px;

    .speed-value {
      width: 70px;
      text-align: left;
    }

    .speed-title {
      text-align: left;
    }
  }

  .speed-input-container {
    display: flex;
    align-items: center;

    .MuiOutlinedInput-root {
      padding-right: 8px;
      background: ${(props) => props.inputValue && 'rgba(30, 22, 78, 0.08)'};
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: -0.4px;
      border-radius: 8px;
    }

    .MuiInputBase-input {
      padding: 12px;
      text-align: center;
    }
  }

  .speed-input {
    color: ${COLOR.darkGray};
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
    flex: 1;
    border-radius: 8px;
    padding: 0px 16px 16px 16px;
  }

  .break-time-input {
    color: ${COLOR.darkGray};
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
    flex: 1;
    border-radius: 8px;
    padding: 0px 16px 16px 16px;

    .MuiInputBase-input {
      margin-left: ${(props) => (props.inputValue ? '35px' : '0px')};
    }
  }

  .icon-choose-speed-input {
    cursor: pointer;
    color: ${(props) =>
      props.inputValue &&
      props?.inputValue >= props?.minValue &&
      props.inputValue <= props?.maxValue
        ? COLOR.blueV2
        : 'gray'};
  }
`;

export const StyledDrawer = styled(Drawer)`
  .MuiPaper-root {
    border-radius: 16px 16px 0px 0px;
  }
  .drawer-title {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    padding: 0 16px;
    background-color: ${COLOR.divider};
    border-bottom: 1px solid ${COLOR.label[16]};
    height: 48px;

    svg:hover {
      cursor: pointer;
    }

    .title {
      font-size: 16px;
      font-weight: bold;
      text-transform: none;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      color: ${COLOR.label2[100]};
      text-overflow: ellipsis;
    }
  }

  .create-voice-button {
    margin: 16px 16px 0px 16px;
  }
`;

export const StyledListItem = styled(ListItem)`
  background-color: ${(props) =>
    props.isSelected ? COLOR.indigo[8] : COLOR.white};
`;

export const StyledLoading = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledIconButton = styled(IconButton)`
  width: ${({ width }) => width || 'auto'};
  padding: ${({ padding }) => padding || '0px'};
  height: ${({ height }) => height || '10px'};
  border-radius: ${({ borderRadius }) => borderRadius || '100%'};
  padding: 18px;
  background: ${({ focus }) => focus && TRANSPARENT_COLOR.dark};

  color: ${({ color }) => (color ? COLOR[color] : COLOR.indigo[64])};
  opacity: 0.75;
  &:hover {
    background: ${TRANSPARENT_COLOR.dark};
    opacity: 1;
    .icon {
      color: ${({ colorHover }) => COLOR[colorHover]};
    }
  }

  .text-action {
    font-size: 14px;
    color: ${COLOR.darkBlue};
    &:hover {
      color: ${COLOR.black};
    }
  }
`;

export const StyledActionWarning = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;

  .cancel-btn {
    display: flex;
    border-radius: 500px;
    border: 1px solid rgba(30, 22, 78, 0.32);
    padding: 10px 24px;
    justify-content: center;
    align-items: center;

    color: ${COLOR.darkBlue};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.4px;
  }

  .agree-btn {
    display: flex;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 500px;
    border: 1px solid ${COLOR.primary};
    background-color: ${COLOR.primary};

    color: ${COLOR.darkBlue};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.4px;
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .agree-btn,
    .cancel-btn {
      width: 50%;
    }
  }
`;

export const StyledBlackWord = styled('span')`
  color: red;

  &:not(:last-child)::after {
    content: ', ';
    color: #242424;
  }
`;
